import React, {Fragment} from 'react';
import {STYLES} from 'core/constants/uiConstants';

const tableDisplay = (headRow, grid, propStyle, freeze = false) => {
  return (
    <table className={`${STYLES.BASIC} ${STYLES.TABLE} ${propStyle.table}`}>
      <thead className={`${STYLES.BASIC} ${STYLES.THEAD} ${propStyle.head}`}>
        <tr className={`${STYLES.BASIC} ${STYLES.TROW} ${propStyle.row}`}>
          {headRow.map((item) => (
            <td
              className={`${STYLES.BASIC} ${STYLES.TDATA} ${propStyle.data} ${
                freeze ? 'headerColumn' : ''
              }`}
              key={item.name}>
              {item.displayName}
            </td>
          ))}
        </tr>
      </thead>
      <tbody className={`${STYLES.BASIC} ${STYLES.TBODY} ${propStyle.body}`}>
        {grid.map((row, index) => (
          <tr key={index}>
            {row.map((val, idx) => (
              <td key={idx} className={`${freeze ? 'headerColumn' : ''}`}>
                {val}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

const CalcTable = ({
  dblTableData,
  columnItems,
  propStyle,
  freezeColumnCount,
}) => {
  if (!dblTableData) {
    return null;
  }


  //We slice off the first row and column as they are index '0' and not used
  const grid = Object.keys(dblTableData)
    .slice(1)
    .map((item, index) => (
      <tr key={index}>
        {dblTableData[item].slice(1).map((col, idx) => (
          <td
            key={idx}
            className={`${idx < freezeColumnCount ? "headerColumn" : ""}`}
            style={{ textAlign: 'right' }}
          >
            {typeof col === 'number' && columnItems[idx]
              ? col.toLocaleString('en-US', {
                  minimumFractionDigits: columnItems[idx].decimalPlaces,
                  maximumFractionDigits: columnItems[idx].decimalPlaces,
                })
              : col}
          </td>
        ))}
      </tr>
    ));

  return (
    <table className={`${STYLES.BASIC} ${STYLES.TABLE} ${propStyle.table}`}>
      <thead className={`${STYLES.BASIC} ${STYLES.THEAD} ${propStyle.head}`}>
        <tr className={`${STYLES.BASIC} ${STYLES.TROW} ${propStyle.row}`}>
          {columnItems.map((item, idx) => (
            <td
              className={`${STYLES.BASIC} ${STYLES.TDATA} ${propStyle.data} ${
                idx < freezeColumnCount ? "headerColumn" : ""
              }`}
              key={item.name}
              style={{ textAlign: "center" }}
            >
              {item.displayName}
            </td>
          ))}
        </tr>
      </thead>

      <tbody className={`${STYLES.BASIC} ${STYLES.TBODY} ${propStyle.body}`}>
        {grid}
      </tbody>
    </table>
  );
};

// CalcTable.defaultProps = {};

export default CalcTable;
